(function exposeTitanScanRuntime(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.TitanScanRuntime = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function createTitanScanRuntime() {
  'use strict';

  function storageKey(config) {
    const value = config && config.storageKey;
    return typeof value === 'string' && /^titan-player-scan:v2:[a-z0-9_-]{1,80}$/i.test(value)
      ? value
      : 'titan-player-scan:v2';
  }

  function asset(config, name, fallback) {
    const value = config && config.assets && config.assets[name];
    return typeof value === 'string' && value ? value : fallback;
  }

  function isShopifyAssetUrl(value) {
    if (typeof value !== 'string' || !value) return false;
    try {
      const url = new URL(value.startsWith('//') ? `https:${value}` : value);
      if (url.protocol !== 'https:') return false;
      const host = url.hostname.toLowerCase();
      const shopifyCdn = host === 'cdn.shopify.com' && /^\/(?:s\/files|cdn\/shop)\//i.test(url.pathname);
      const titanStorefront = ['titan-pc.net', 'www.titan-pc.net'].includes(host);
      const shopifyStorefront = host.endsWith('.myshopify.com');
      return shopifyCdn || ((titanStorefront || shopifyStorefront) && /^\/cdn\/shop\//i.test(url.pathname));
    } catch (error) {
      return false;
    }
  }

  function isScanHistoryState(value) {
    return Boolean(value && typeof value === 'object' && value.titanPlayerScan === true);
  }

  function publicResultUrl(value, currentOrigin) {
    if (typeof value !== 'string' || !value.trim() || !currentOrigin) return null;
    try {
      const url = new URL(value, currentOrigin);
      if (!['http:', 'https:'].includes(url.protocol) || url.origin !== currentOrigin) {
        return null;
      }
      url.username = '';
      url.password = '';
      const approvedView = url.searchParams.get('view') === 'titan-player-scan-v2';
      url.search = '';
      if (approvedView) url.searchParams.set('view', 'titan-player-scan-v2');
      url.hash = '';
      return url;
    } catch (error) {
      return null;
    }
  }

  function reloadOnSectionLoad(selector) {
    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (target && (target.matches?.(selector) || target.querySelector?.(selector))) {
        window.location.reload();
      }
    });
  }

  return Object.freeze({
    storageKey,
    asset,
    isShopifyAssetUrl,
    isScanHistoryState,
    publicResultUrl,
    reloadOnSectionLoad,
  });
});
